<template>
  <div @mouseup="isDraggingHandler($event, false)">
    <LogoutPopup
      v-if="logoutPopup"
      @CancelClose="closeLogoutPopup"
      @logoutProcess="logoutProcess"
    />
    <AIoTHeader
      @saveClick="saveData"
      @clearClick="clearAll"
      @loadFunction="loadModel"
      @logoutClick="logoutClick"
      curPage="vision"
    />
    <div class="mainDiv" @mousemove="handledrag">
      <div class="area videoArea" :style="{ width: `${videoSize}px` }">
        <h1>Real-Time Video</h1>
        <div :class="{ videoContainer: true, continueTrain: continueTrain }">
          <div class="videoWrapper" :style="{ transform: `rotate(${rotateDeg}deg)` }">
            <video
              v-show="!isWifiCameraOn"
              class="mainframe"
              ref="video"
              id="video"
              autoplay
              poster="@/assets/icon/camera_no.png"
            ></video>
            <canvas
              class="mainframe"
              v-show="isWifiCameraOn"
              height="320" width="480"
              ref="wifiVideo"
            />
          </div>
        </div>
        <div class="videoButtonArea">
          <button @click="viedoRotate(-90)">
            <img src="@/assets/icon/img_turn_left.png" />
          </button>
          <button @click="viedoRotate(90)">
            <img src="@/assets/icon/img_turn_right.png" />
          </button>
        </div>
      </div>
      <div
        class="resizeBtn"
        @mousedown="isDraggingHandler($event, true)"
        @mouseup="isDraggingHandler($event, false)"
      >
        <div class="resizePagination"></div>
      </div>
      <div class="area trainArea">
        <h1>Model Training List</h1>
        <div class="listArea">
          <ul :class="{ columeList: isCloumsList }">
            <li
              v-for="(item, index) in list"
              :key="index"
              :class="{ modelClass: true, modelInColumnList: isCloumsList }"
            >
              <img src="@/assets/icon/class_minus.png"
              @click="removeList(index)" v-if="!isCloumsList" />
              <div class="firstPart">
                <div class="modelClassIdx">{{ `0${index + 1}`.slice(-2) }}</div>
                <input
                  class="modelName"
                  type="text"
                  v-model="item.name"
                  :placeholder="'Class ' + (index + 1)"
                />
                <div class="progress customProgress">
                  <p class="confidenceTitle">Confidence</p>
                  <div
                    class="progress-bar progress-bar-striped progress-bar-animated custom-bg"
                    role="progressbar"
                    :style="{ width: item.confidence + '%' }"
                  ></div>
                  <p class="confidenceValue">{{ item.confidence + "%" }}</p>
                </div>
              </div>
              <div class="secondPart" v-if="!isCloumsList">
                <div class="exampleNumber">{{ item.examples + " examples" }}</div>
                <div class="trainBtnArea">
                  <input
                    type="number"
                    class="trainAmount"
                    v-model.number="item.trainAmount"
                    @blur="validateAmount(index)"
                  />
                  <div class="amountBtnArea">
                    <div @click="changeTrainAmount(index, 1)" class="amountBtn">
                      <icon-base width="11" height="10"><TriangleUp /></icon-base>
                    </div>
                    <div @click="changeTrainAmount(index, -1)" class="amountBtn">
                      <icon-base width="11" height="10"><TriangleDown /></icon-base>
                    </div>
                  </div>
                  <button class="trainBtn" @click="doTrain(index)" :disabled="!aCameraOn">
                    Train
                    <div
                      :class="{
                        traingLight: rightNowTrain !== index,
                        doingTrain: rightNowTrain === index
                      }"
                    ></div>
                  </button>
                </div>
                <button class="resetBtn" @click="doReset(index)">
                  Reset
                </button>
              </div>
            </li>
            <li :class="{ modelClass: true, modelInColumnList: isCloumsList }">
              <img src="@/assets/icon/class_add.png" @click="addNewClass()" v-if="!isCloumsList" />
            </li>
          </ul>
        </div>
        <div class="trainButtonArea">
          <button :class="{ drawer: true, drawerOpen: isDrawerOpen }" @click="toggleDrawer">
            <img src="@/assets/icon/img_drawer.png" />
          </button>
          <div class="drawerBox" v-show="isDrawerOpen">
            <div class="drawerCloseBtn" @click="toggleDrawer">×</div>
            <p>Trained Model</p>
            <div class="modelContainer">
              <div
                class="AIModel"
                v-for="el in Object.keys(exportKnnClassifiers)"
                :key="el"
                :title="el"
              >
                <div class="block" :data-text="el"></div>
                <p>{{ el }}</p>
                <span class="modelDeleteBtn" @click="deleteClassifier(el)">&times;</span>
              </div>
            </div>
          </div>
          <button class="export" @click="exportClassifier">Export</button>
          <button class="functionBtn" @click="toggleCloumsList">
            <img
              :src="require(`@/assets/icon/${isCloumsList ?
              'columeList_on' : 'columeList_off'}.png`)"
            />
          </button>
        </div>
      </div>
    </div>
    <loadingPage v-show="isloading" />
    <ContinueTrainModel
      :classes="list"
      :curIdx="rightNowTrain"
      :count="trainCount"
      v-if="continueTrain"
      @stop="stopIntervalTrain"
    />
  </div>
</template>

<script>
import AIoTHeader from '@/components/AIoTHeader.vue';
import LogoutPopup from '@/components/LogoutPopup.vue';
import loadingPage from '@/components/loadingPage.vue';
import ContinueTrainModel from '@/components/ContinueTrainModel.vue';
import { mapState, mapMutations } from 'vuex';
import * as tf from '@tensorflow/tfjs';
import * as knnClassifier from '@tensorflow-models/knn-classifier/dist/knn-classifier';
import Swal from 'sweetalert2';

import IconBase from '@/icons/IconBase.vue';
import TriangleUp from '@/icons/triangleUp.vue';
import TriangleDown from '@/icons/triangleDown.vue';

const swalWithCustomClass = Swal.mixin({
  customClass: {
    container: 'custom-confirm',
    confirmButton: 'button-confirm',
    cancelButton: 'button-cancel',
  },
  allowOutsideClick: false,
  buttonsStyling: false,
});

export default {
  components: {
    AIoTHeader,
    LogoutPopup,
    loadingPage,
    IconBase,
    TriangleUp,
    TriangleDown,
    ContinueTrainModel,
  },
  data() {
    return {
      rotateDeg: 0,
      isDrawerOpen: false,
      isCloumsList: false,

      classifyInterval: null,
      list: [],
      classifier: null,
      logoutPopup: false,
      cameraPopup: false,
      isloading: false,

      trainInterval: null,
      rightNowTrain: -1,
      trainCount: 0,
      continueTrain: false,

      isAdjustSize: false,
      prex: 0,
    };
  },
  beforeMount() {
    window.addEventListener('beforeunload', this.preventNav);
  },

  beforeDestroy() {
    console.log('before leave');
    this.stopClassify();
    if (this.list.length) {
      this.cacheKnnClassifier({ knn: this.classifier, list: this.list });
    }
    window.removeEventListener('beforeunload', this.preventNav);
  },
  async mounted() {
    this.setCameraRef({
      cameraRef: this.$refs.video,
      wifiCameraRef: this.$refs.wifiVideo,
    });
    if (!this.mobilenet) {
      this.isloading = true;
      this.$store
        .dispatch('loadMobilenet')
        .then((res) => {
          console.log(res);
          this.isloading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isloading = false;
          swalWithCustomClass.fire({
            title: 'Error',
            text: 'AI module load error, please check the internet',
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            showCancelButton: true,
            showCloseButton: true,
            reverseButtons: true,
          });
        });
    }
    if (this.cacheKnn !== null) {
      console.log('set knn from vuex');
      this.classifier = this.cacheKnn.knn;
      this.list = this.cacheKnn.list;
      this.processClassify();
    } else {
      console.log('set knn local');
      this.classifier = knnClassifier.create();
      this.initList();
      this.processClassify();
    }
    console.log('mounted?');
    // this.webcam.play();
  },
  computed: {
    ...mapState([
      'videoSize',
      'mobilenet',
      'exportKnnClassifiers',
      'isFetchErr',
      'fetchErrorMsg',
      'cacheKnn',
      'cameraRef',
      'wifiCameraRef',
      'isCameraOn',
      'isWifiCameraOn',
    ]),
    aCameraOn() {
      return this.isCameraOn || this.isWifiCameraOn;
    },
  },
  methods: {
    ...mapMutations([
      'videoSizeAdjust',
      'addNewClassifier',
      'removeClassifier',
      'cacheKnnClassifier',
      'logout',
      'setCameraRef',
    ]),
    validateAmount(idx) {
      const newNumber = this.list[idx].trainAmount;
      // console.log('blur?', idx, newNumber);
      if (!newNumber || typeof newNumber === 'string') {
        this.list[idx].trainAmount = 1;
      } else if (newNumber < 1) {
        this.list[idx].trainAmount = 1;
      } else if (newNumber > 99) {
        this.list[idx].trainAmount = 99;
      } else {
        this.list[idx].trainAmount = Math.round(newNumber);
      }
    },
    preventNav(event) {
      // console.log(event)
      event.preventDefault();
      // eslint-disable-next-line no-param-reassign
      event.returnValue = 'dscldsnclsdcnd';
      // return 'dsnclsncldnsclsd'
    },
    isDraggingHandler(event, value) {
      console.log(event);
      if (value) {
        this.prex = event.clientX;
      }
      this.isAdjustSize = value;
    },
    handledrag(e) {
      if (this.isAdjustSize) {
        const delta = this.prex - e.clientX;
        this.videoSizeAdjust(this.videoSize - delta);
        this.prex = e.clientX;
      }
    },
    closeCameraPopup() {
      this.cameraPopup = false;
    },
    viedoRotate(degree) {
      this.rotateDeg = (this.rotateDeg + degree) % 360;
    },
    toggleDrawer() {
      this.isDrawerOpen = !this.isDrawerOpen;
    },
    toggleCloumsList() {
      this.isCloumsList = !this.isCloumsList;
    },
    logoutClick() {
      console.log('log out click from chart');
      this.logoutPopup = true;
    },
    closeLogoutPopup() {
      this.logoutPopup = false;
    },
    logoutProcess() {
      this.logout();
      this.$router.replace({ path: 'login' });
    },
    initList() {
      for (let i = 0; i < 2; i += 1) {
        this.list.push({
          class: i.toString(),
          name: `Class ${i + 1}`,
          confidence: 0,
          examples: 0,
          trainAmount: 1,
        });
      }
    },
    /**
     * 新增按鈕的觸發功能
     * 新增一筆訓練class
     * 以timestamp作為class值:key(隱藏)(不重複)
     * 以輸入作為name:名稱(可見)(可重複)
     */
    addNewClass() {
      const timestamp = Math.floor(Date.now() / 100).toString();
      this.list.push({
        class: timestamp,
        name: '',
        confidence: 0,
        examples: 0,
        trainAmount: 1,
      });

      this.list.forEach((e, index) => {
        if (e.name === '') {
          e.name = `Class ${index + 1}`;
        }
      });
    },
    saveData() {
      swalWithCustomClass
        .fire({
          title: 'Save',
          text: 'Model training list file name.',
          input: 'text',
          inputAttributes: {
            autocapitalize: 'off',
          },
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          showCancelButton: true,
          showCloseButton: true,
          reverseButtons: true,
          // eslint-disable-next-line consistent-return
          inputValidator: (value) => {
            if (!value) {
              return 'You need to write something!';
            }
          },
        })
        .then((result) => {
          console.log(result);
          if (result.isConfirmed) {
            const a = document.createElement('a');
            const data = JSON.stringify(this.preSave());
            const file = new Blob([data], { type: 'application/json' });
            a.href = URL.createObjectURL(file);
            a.download = `${result.value}.aiot`;
            a.click();
          }
        });
    },
    loadModel(result) {
      swalWithCustomClass
        .fire({
          title: 'Load',
          text: 'The existing AI models will be overwritten. Are you sure to load the file?',
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          showCancelButton: true,
          showCloseButton: true,
          reverseButtons: true,
        })
        .then((res) => {
          if (res.isConfirmed) {
            console.log('load file', result, this);
            this.stopClassify();
            const { dataset, tensors } = result;
            const sortedKeys = Object.keys(dataset).sort();
            const tensorsData = tensors
              .map((tensor, i) => {
                if (tensor) {
                  const values = Object.keys(tensor).map((v) => tensor[v]);
                  const key = sortedKeys[i];
                  return tf.tensor(values, dataset[key].shape, dataset[key].dtype);
                }
                return null;
              })
              .reduce((acc, cur, j) => {
                // j means index
                // set key like '0000001...'
                const key = sortedKeys[j];
                acc[key] = cur;
                return acc;
              }, {});

            // save的資料已經排序過了
            // console.log(sortedKeys);
            this.list = [];
            for (let i = 0; i < sortedKeys.length; i += 1) {
              // console.log(sortedKeys[i]);
              const key = sortedKeys[i];
              this.list.push({
                class: key,
                name: dataset[key].name,
                confidence: 1,
                examples: dataset[key].shape[0],
                duplicate: false,
              });
            }
            this.classifier.setClassifierDataset(tensorsData);
            this.processClassify();
          }
        });
    },
    /**
     * clear  classifyInterval
     */
    stopClassify() {
      clearInterval(this.classifyInterval);
    },
    /**
     * set a interval
     * 要求knnClassifier 回應 目前影像的信心值
     */
    processClassify() {
      console.log('classifiy!');
      const vm = this;
      const classifyFunction = () => {
        let logits;
        let infer;
        if (this.isCameraOn) {
          infer = () => this.mobilenet.infer(this.cameraRef, 'conv_preds');
        } else if (this.isWifiCameraOn) {
          infer = () => this.mobilenet.infer(this.$refs.wifiVideo, 'conv_preds');
        } else {
          return;
        }

        const numClasses = Object.keys(this.classifier.getClassExampleCount()).length;
        if (numClasses > 0) {
          logits = infer();

          this.classifier
            .predictClass(logits, 10)
            .then((result) => {
              console.log(result);
              Object.keys(result.confidences).forEach((el) => {
                for (let i = 0; i < vm.list.length; i += 1) {
                  if (vm.list[i].class === el) {
                    vm.list[i].confidence = Math.floor(result.confidences[el] * 100);
                    break;
                  }
                }
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      };

      this.classifyInterval = setInterval(classifyFunction, 200);
    },
    changeTrainAmount(idx, value) {
      const newVal = Math.min(Math.max(this.list[idx].trainAmount + value, 1), 99);
      this.$set(this.list[idx], 'trainAmount', newVal);
    },
    /**
     * doTrain按鈕觸發功能
     */
    async doTrain(index) {
      const fn = () => {
        const className = this.list[index].class;
        let logits;
        if (this.isCameraOn) {
          logits = this.mobilenet.infer(this.cameraRef, 'conv_preds');
        } else if (this.isWifiCameraOn) {
          logits = this.mobilenet.infer(this.$refs.wifiVideo, 'conv_preds');
        }

        console.log(logits);

        this.classifier.addExample(logits, className);
        this.list[index].examples = this.classifier.getClassExampleCount()[className];
      };

      const popupChecker = () => {
        if (!this.aCameraOn) {
          console.log('webcam not exist');
          return false;
        }
        return true;
      };

      const intervalTrain = () => {
        if (this.trainCount < this.list[index].trainAmount) {
          this.trainCount += 1;
          fn();
        } else {
          this.stopIntervalTrain();
        }
      };

      if (popupChecker()) {
        if (this.list[index].trainAmount === 1) {
          fn();
        } else {
          this.continueTrain = true;
          this.trainCount = 0;
          this.rightNowTrain = index;
          this.trainInterval = setInterval(intervalTrain, 1000);
        }
      }
    },

    stopIntervalTrain() {
      clearInterval(this.trainInterval);
      this.rightNowTrain = -1;
      this.continueTrain = false;
    },
    /**
     * 刪除按鈕的觸發功能
     * 詢問是否移除，並清除list上其中一筆資料及knnClassifier上的一筆資料
     */
    removeList(index) {
      swalWithCustomClass
        .fire({
          title: 'Delete',
          text: 'Are you sure to delete the class?',
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          showCancelButton: true,
          showCloseButton: true,
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.stopClassify();
            const className = this.list[index].class;
            this.$delete(this.list, index);
            this.classifier.clearClass(className);
            this.processClassify();
          }
        });
    },
    /**
     * Reset按鈕觸發功能
     * 詢問是否reset，修改list上其中一筆的部分資料，清除knnClassifier上的一筆資料
     */
    doReset(index) {
      swalWithCustomClass
        .fire({
          title: 'Reset',
          text: 'Are you sure to reset the class?',
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          showCancelButton: true,
          showCloseButton: true,
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.stopClassify();
            const className = this.list[index].class;
            this.list[index].confidence = 0;
            this.list[index].examples = 0;
            this.list[index].duplicate = false;
            this.classifier.clearClass(className);
            this.processClassify();
          }
        });
    },
    /**
     * clearAll按鈕的觸發功能
     * 詢問是否清除全部，list全部清除、knnClassifier全部清除
     */
    clearAll() {
      swalWithCustomClass
        .fire({
          title: 'Clear All',
          text: 'Are you sure to clear all model training list?',
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          showCancelButton: true,
          showCloseButton: true,
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.stopClassify();
            this.list.splice(0, this.list.length);
            this.classifier.clearAllClasses();
            this.initList();
            this.processClassify();
          }
        });
    },
    preSave() {
      const dataset = {
        ...this.classifier.getClassifierDataset(),
      };
      const vm = this;
      function findMatchIndex(key) {
        let targetIndex = 0;
        vm.list.forEach((e, index) => {
          if (e.class === key) {
            targetIndex = index;
          }
        });
        return targetIndex;
      }
      Object.keys(dataset).forEach((key) => {
        console.log(key);
        const indexforList = findMatchIndex(key);
        dataset[key].calss = vm.list[indexforList].class;
        dataset[key].name = vm.list[indexforList].name;
      });
      console.log(dataset);

      const tensors = Object.keys(dataset)
        .sort()
        .map((key) => {
          const t = dataset[key];
          if (t) {
            return t.dataSync();
          }
          return null;
        });

      return { dataset, tensors };
    },
    exportClassifier() {
      if (this.isDrawerOpen) {
        this.toggleDrawer();
      }
      swalWithCustomClass
        .fire({
          title: 'Export',
          input: 'text',
          text: 'Name your AI models.',
          showCancelButton: true,
          // eslint-disable-next-line consistent-return
          inputValidator: (value) => {
            if (!value) {
              return 'You need to write something!';
            }
            if (Object.keys(this.exportKnnClassifiers).includes(value)) {
              return 'This model name already used!';
            }
          },
        })
        .then((result) => {
          if (result.isConfirmed) {
            const { dataset, tensors } = this.preSave();
            const name = result.value;
            const sortedKeys = Object.keys(dataset).sort();
            const tensorsData = tensors
              .map((tensor, i) => {
                if (tensor) {
                  const values = Object.keys(tensor).map((v) => tensor[v]);
                  const key = sortedKeys[i];
                  return tf.tensor(values, dataset[key].shape, dataset[key].dtype);
                }
                return null;
              })
              .reduce((acc, cur, j) => {
                // j means index
                // set key like '0000001...'
                const key = sortedKeys[j];
                acc[key] = cur;
                return acc;
              }, {});
            this.addNewClassifier({
              name,
              tensorsData,
              dataset,
              tensors,
            });
          }
        });
    },
    deleteClassifier(name) {
      this.removeClassifier(name);
    },
  },
};
</script>
<style lang="scss">
.custom-confirm {
  .swal2-popup {
    width: 380px;
  }
  .swal2-modal {
    font-family: Arial;

    background-color: #f3f5f9;
    padding: 0;
    border-radius: 10px;
    overflow: hidden;

    .swal2-actions {
      justify-content: flex-end;
    }

    .swal2-header {
      position: relative;
      height: 35px;
      line-height: 35px;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
      background-color: #ffffff;
      .swal2-title {
        margin-bottom: 0;
        font-size: 13px;
        color: #282828;
        height: 35px;
        line-height: 35px;
      }
      .swal2-close {
        height: 35px;
        width: 35px;
        line-height: 35px;
        &:hover {
          color: #39e2cf;
        }
      }
    }

    .swal2-content {
      padding: 20px 15px;
      font-size: 16px;
      text-align: left;
      color: #282828;
    }
    .swal2-actions {
      margin-bottom: 33px;
      margin-top: 0px;
      height: 36px;
      display: flex;
    }

    .button-confirm,
    .button-cancel {
      padding: 0;
      color: white;
      width: 105px;
      height: 35px;
      align-items: center;
      font-size: 20px;
      border: none;

      &:hover {
        color: white;
      }
    }

    .button-confirm {
      background-color: #37ccda;

      width: 50%;
      &:hover {
        background-image: linear-gradient(to right, #23cfbb 0%, #2a9ec9);
      }
      &:focus {
        color: white;
        outline: none !important;
        box-shadow: none !important;
      }
    }
    .button-cancel {
      background-color: #9b9c9e;
      color: #282828;

      width: 50%;

      &:hover {
        background-color: #b3b4b5;
        color: #ffffff;
        border: solid 1px #999999;
      }
      &:focus {
        outline: none !important;
        box-shadow: none !important;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.mainDiv {
  position: absolute;
  top: 160px;
  width: 100vw;
  bottom: 0px;
  display: flex;
  min-height: 500px;
  .area {
    display: flex;
    padding: 37px 0px 30px 0px;
    align-items: center;
    flex-direction: column;
  }
  .resizeBtn {
    width: 15px;
    height: 100%;
    background-color: #3c3d3e;
    display: flex;
    right: 3px;
    cursor: col-resize;
    .resizePagination {
      width: 4px;
      height: 92px;
      opacity: 0.8;
      border-radius: 7px;
      background-color: #727374;
      margin: auto;
    }
    &:hover {
      .resizePagination {
        box-shadow: 0 0 5px 0 #ffffff;
        background-color: #ffffff;
      }
    }
  }
  .trainArea {
    flex-grow: 1;
    background-color: #000000;
    position: relative;
    .listArea {
      width: 90%;
      // border: solid;
      height: 80%;
      padding-top: 70px;
      max-width: 850px;
      ::-webkit-scrollbar {
        width: 10px !important;
      }
      ::-webkit-scrollbar-corner {
        background: rgba(0, 0, 0, 0.5);
      }
      ::-webkit-scrollbar-thumb {
        background: #4b4c4d;
        border-radius: 10px;
      }
      ::-webkit-scrollbar-track {
        background: #000;
        border-radius: 10px;
      }
      ul {
        height: 100%;
        overflow: scroll;
      }
      .columeList {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
      }
      .modelClass {
        display: flex;
        // justify-content: space-around;
        width: 90%;
        height: 35px;
        margin-bottom: 18px;
        align-items: center;
        img {
          width: 26px;
          margin-right: 10px;
          cursor: pointer;
        }
        .firstPart {
          display: flex;
          margin-left: 10px;
          flex: 1;
          .modelClassIdx {
            width: 35px;
            height: 35px;
            background-color: #727374;
            font-family: Arial;
            font-size: 15px;
            font-weight: bold;
            color: #f3f5f9;
            line-height: 35px;
            margin-right: 5px;
            flex-basis: 35px;
          }
          .modelName {
            height: 35px;
            outline: none;
            margin-right: 5px;
            width: 35%;
            flex-shrink: 1;
            &.isduplicate {
              color: red;
            }
          }
          .customProgress {
            flex: 1 0;
            height: 35px;
            background-color: #4b4c4d;
            border-radius: 0px;
            position: relative;
            .custom-bg {
              background-color: #37ccda;
            }
            .confidenceTitle {
              font-size: 15px;
              color: #727374;

              line-height: 35px;
              position: absolute;
              left: 10px;
            }
            .confidenceValue {
              font-size: 18px;
              color: #ffffff;
              position: absolute;
              line-height: 35px;
              right: 10px;
            }
            @media (max-width: 1100px) {
              .confidenceTitle {
                display: none;
              }
            }
          }
        }
        .secondPart {
          display: flex;
          align-items: center;
          justify-content: center;
          // width: 100%;
          .exampleNumber {
            font-size: 18px;
            color: #727374;
            padding: 0px 10px;
            width: 130px;
          }
          button {
            width: 80px;
            height: 35px;
            border-radius: 35px;
            border: solid 1px #727374;
            color: #727374;
            background-color: transparent;
          }
          .trainBtnArea {
            display: flex;
            flex-direction: row;
            .trainAmount {
              width: 35px;
              height: 35px;
              border: solid 1px #23b6bc;
              background-color: #ffffff;
              color: #707070;
              border-radius: 10px 0px 0px 10px;
              line-height: 35px;
              align-items: center;
              margin-right: 1px;
              text-align: center;
            }
            input:focus{
              outline: none;
            }
            input::-webkit-outer-spin-button,
            input::-webkit-inner-spin-button {
              -webkit-appearance: none;
              margin: 0;
            }
            .amountBtnArea {
              margin-right: 1px;
              .amountBtn {
                width: 17px;
                height: 17px;
                border: solid 1px #23b6bc;
                background-color: #ffffff;
                margin-bottom: 1px;
                border-radius: 2px;
                cursor: pointer;
                fill: #23b6bc;
                &:hover {
                  background-color: #23b6bc;
                  fill: #ffffff;
                }
              }
            }
            .trainBtn {
              border: solid 1px #37ccda;
              color: #37ccda;
              margin-right: 10px;
              border-radius: 0px 35px 35px 0px;
              display: flex;
              align-items: center;
              line-height: 35px;
              .traingLight {
                width: 15px;
                height: 15px;
                border: solid 1px #23b6bc;
                border-radius: 120px;
                margin-left: 10px;
              }
              .doingTrain {
                width: 15px;
                height: 15px;
                border: solid 1px #ffffff;
                background-color: #ffb507;
                border-radius: 120px;
                margin-left: 10px;
                // animation: lightani 2s infinite;
              }
              &:disabled {
                cursor: not-allowed;
              }
              &:hover {
                background-color: #37ccda;
                color: white;
                .traingLight {
                  border: solid 1px #f3f5f9;
                  background-color: #9b9c9e;
                }
              }
            }
          }
          .resetBtn {
            &:hover {
              background-color: #727374;
              color: white;
            }
          }
        }
      }
      .modelInColumnList {
        width: 49%;
      }
    }
    .trainButtonArea {
      display: flex;
      position: absolute;
      bottom: 25px;
      width: 100%;
      padding-left: 80px;
      .drawer {
        width: 63px;
        height: 35px;
        background-color: #4b4c4d;
        border-radius: 18px 0px 0px 18px;
        border: none;
        img {
          height: 29px;
          margin-left: 4px;
        }
      }
      .drawerOpen {
        border-radius: 0px 0px 0px 18px;
      }
      .drawerBox {
        position: absolute;
        height: 200px;
        width: 420px;
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.2);
        background-color: #4b4c4d;
        bottom: 37px;
        left: 80px;
        border-radius: 5px 5px 5px 0px;
        padding: 0px 20px;
        .modelContainer {
          width: 380px;
          height: 140px;
          border-radius: 10px;
          background-color: #f3f5f9;
          padding: 13px;
          display: flex;
          flex-wrap: wrap;
          overflow-y: scroll;
          align-content: space-between;
          .AIModel {
            height: 65px;
            width: 59px;
            position: relative;
            .modelDeleteBtn {
              position: absolute;
              top: -1px;
              right: 8px;
              font-weight: 500;
              display: none;
              cursor: pointer;
              color: #4b4c4d;
            }
            &:hover {
              .modelDeleteBtn {
                display: block;
              }
            }
            .block {
              height: 35px;
              width: 35px;
              background-color: #282828;
              border-radius: 5px;
              margin: 5px 12px;
            }
            p {
              font-size: 12px;
              color: #282828;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              width: 59px;
              height: 12px;
              padding: 5px;
              line-height: 0px;
              text-align: center;
            }
          }
        }
        p {
          height: 17px;
          font-family: Arial;
          font-size: 16px;
          color: #ffffff;
          padding: 9px 0px;
          text-align: left;
        }
        .drawerCloseBtn {
          position: absolute;
          top: 9px;
          right: 15px;
          color: #ccc;
          font-size: 35px;
          cursor: pointer;
          line-height: 15px;
          &:hover {
            color: #39e2cf;
          }
        }
      }
      .export {
        width: 166px;
        height: 35px;
        background-color: #4b4c4d;
        margin-left: 2px;
        margin-right: 7px;
        border-radius: 0px 18px 18px 0px;
        border: none;
        font-family: Arial;
        font-size: 20px;
        font-weight: bold;
        color: #37ccda;
      }
      .functionBtn {
        border: none;
        background-color: #4b4c4d;
        border-radius: 18px;
        margin-left: 30px;
        height: 35px;
        width: 35px;
        img {
          height: 20px;
          width: 20px;
        }
      }
    }
  }

  .videoArea {
    // flex-basis: 35%;
    background-color: #3c3d3e;
    position: relative;
    // min-width: 400px;
    // max-width: 500px;
    .continueTrain {
      z-index: 1001;
    }
    .videoContainer {
      height: 400px;
      width: 100%;
      display: flex;
      justify-content: center;
      padding-top: 70px;
      .videoWrapper {
        border-radius: 5px;
        overflow: hidden;
        width: 85%;
        padding-top: 56.25%;
        height: 0px;
        position: relative;
        .mainframe {
          width: 100%;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
    }
    .videoButtonArea {
      display: flex;
      position: absolute;
      bottom: 25px;
      button {
        width: 145px;
        height: 35px;
        border-radius: 18px;
        border: solid 1px #9b9c9e;
        background-color: transparent;
        margin: 0px 5px;
        &:hover {
          background-color: #ffffff;
        }
        img {
          height: 23px;
        }
      }
    }
  }
  h1 {
    font-family: Arial;
    font-size: 23px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    text-align: left;
    color: #c6c8cb;
  }
}

@keyframes lightani {
  0% {
    transform: scale(1);
  }
  70% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
</style>
